import React from 'react';
import classnames from 'classnames';

import { connect } from 'react-redux';

import styles from './index.scss';

import moment from 'moment';
import forOwn from 'lodash/forOwn';

import RangedDtPicker from '../../../components/RangedDtPicker';
import { FiguresSection } from './FiguresSection';

import { AlertsAndAnomaliesChart } from './RiskViewCharts/AlertsAndAnomalies';
import { AlertsYieldChart } from './RiskViewCharts/AlertsYield';
import { NoIssueL1Chart } from './RiskViewCharts/NoIssueAndL1';
import { StrChart } from './RiskViewCharts/Str';
import { AlertStatusBreakdownChart } from './RiskViewCharts/AlertStatusBreakdown';
import { CustomerViewChart } from './RiskViewCharts/CustomerView';
import { ClusterViewChart } from './RiskViewCharts/ClusterView';

import {
  getAlertsAnomaliesChart,
  getAlertStatusChart,
  getAlertsYieldChart,
  getCustomerClusterChart,
  getCustomerData,
  getFigureData,
  getNoIssueL1Chart,
  getSegmentListData,
  getStrChart
} from '../../../redux/actions/tm/dashboard';

import { tmUserManagementResources } from '../../../util/GlobalConstant';
import { getItemFromLocalStorage } from '../../../util/localStorageUtils';
import { isUiResourceAvailable } from '../../../util/index';
import { ConfigData } from '../../../util/ABUtil';

const defaultSegment = {
  code: '-',
  id: '-',
  name: 'All Segments'
};

export class Dashboard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedDateRange: {
        startDate: moment().subtract(30, 'days').add(1, 'days'),
        endDate: moment(),
        activeRangeNo: 2
      },
      isAlertsAndAnomaliesCollapsed: false,
      isAlertsYieldCollapsed: false,
      isCustomerViewCollapsed: false,
      isCustomerClusterCollapsed: false,
      isNoIssueL1Collapsed: false,
      isStrCollapsed: false,
      isAlertStatusBreakdownCollapsed: false,
      alertStatusBreakdownFilter: {},
      selectedSegmentCustomerView: defaultSegment,
      selectedCustomerClusterAxis: 0
    };
  }

  componentDidMount() {
    const { selectedDateRange } = this.state;
    const requestParams = {
      to: moment(selectedDateRange.endDate).format('DD/MM/YYYY'),
      from: moment(selectedDateRange.startDate).format('DD/MM/YYYY')
    };

    const selectedPeriod = {
      from: selectedDateRange.startDate.clone().format('DD/MM/YYYY'),
      to: selectedDateRange.endDate.clone().format('DD/MM/YYYY')
    };

    let previousPeriod = null;
    const clonedStartDate = selectedDateRange.startDate.clone();
    const clonedEndDate = selectedDateRange.endDate.clone();

    const difference = clonedEndDate.diff(clonedStartDate);
    previousPeriod = {
      from: clonedStartDate.subtract(difference).format('DD/MM/YYYY'),
      to: clonedEndDate.subtract(difference).format('DD/MM/YYYY')
    };
    this.props?.fetchFigureData({
      currentPeriod: selectedPeriod,
      previousPeriod
    });

    this.props?.fetchSegmentList();

    // start user management validation here

    this.fetchDashboardDataWithRequestParams(requestParams);
  }

  onAlertBreakdownChartFilter = (filterPref) => {
    let alertStatusBreakdownFilter = this.state.alertStatusBreakdownFilter;

    forOwn(filterPref, (value, key) => {
      alertStatusBreakdownFilter[key] = value;
    });

    let isAllSegmentsSelected = false;
    let selectedSegments = '';
    if (alertStatusBreakdownFilter?.['Segments']) {
      const segmentFilters = alertStatusBreakdownFilter['Segments'];
      Object.keys(segmentFilters).forEach((o) => {
        if (o === '-') {
          if (segmentFilters[o]) {
            isAllSegmentsSelected = true;
          }
          return;
        }

        if (segmentFilters[o]) {
          selectedSegments += `${o}\n`;
        }
        return;
      });
    }

    if (filterPref?.Segments) {
      let allSegments = true;
      let commaSeparatedSegmentFilter = '';
      Object.keys(filterPref.Segments).forEach((segment) => {
        if (filterPref.Segments[segment]) {
          commaSeparatedSegmentFilter += `${segment},`;
        } else {
          allSegments = false;
        }
      });

      const { selectedDateRange } = this.state;
      if (!allSegments) {
        const requestParams = {
          to: moment(selectedDateRange.endDate).format('DD/MM/YYYY'),
          from: moment(selectedDateRange.startDate).format('DD/MM/YYYY'),
          customerSegment: commaSeparatedSegmentFilter
        };

        this.props?.fetchAlertStatusBreakdown(requestParams);
      } else {
        const requestParams = {
          to: moment(selectedDateRange.endDate).format('DD/MM/YYYY'),
          from: moment(selectedDateRange.startDate).format('DD/MM/YYYY')
        };

        this.props?.fetchAlertStatusBreakdown(requestParams);
      }
    }

    this.setState({
      ...this.state,
      alertStatusBreakdownFilter
    });
  };

  onClusterViewAxisChange = (axis) => {
    this.setState({
      ...this.state,
      selectedCustomerClusterAxis: axis
    });
  };

  onCustomerViewSegmentChange = (segment) => {
    const { selectedDateRange } = this.state;
    const requestParams = {
      to: moment(selectedDateRange.endDate).format('DD/MM/YYYY'),
      from: moment(selectedDateRange.startDate).format('DD/MM/YYYY')
    };

    if (segment.code !== '-') {
      requestParams.segment = segment.code;
    }

    this.setState(
      {
        ...this.state,
        selectedSegmentCustomerView: segment
      },
      () => {
        this.props?.fetchCustomerViewData(requestParams);
      }
    );
  };

  onDateChange = (start, end, rangeNo) => {
    const newDateRange = {
      startDate: start,
      endDate: end,
      activeRangeNo: rangeNo
    };

    this.setState(
      {
        ...this.state,
        selectedDateRange: newDateRange,
        selectedSegmentCustomerView: defaultSegment
      },
      () => {
        const requestParams = {
          to: moment(end).format('DD/MM/YYYY'),
          from: moment(start).format('DD/MM/YYYY')
        };

        const selectedPeriod = {
          from: start.clone().format('DD/MM/YYYY'),
          to: end.clone().format('DD/MM/YYYY')
        };

        let previousPeriod = null;
        const clonedStartDate = start.clone();
        const clonedEndDate = end.clone();

        const difference = clonedEndDate.diff(clonedStartDate);
        if (difference === 86399000) {
          // if difference is 1 day, eg user select same day 2020-07-20 -> 2020-07-20
          //we want to make sure the previous period is 2020-07-19 -> 2020-07-19, not 2020-07-19 -> 2020-07-20
          previousPeriod = {
            from: clonedStartDate.subtract(difference).format('DD/MM/YYYY'),
            to: clonedEndDate.subtract(difference + 1).format('DD/MM/YYYY')
          };
        } else {
          previousPeriod = {
            from: clonedStartDate.subtract(difference).format('DD/MM/YYYY'),
            to: clonedEndDate.subtract(difference).format('DD/MM/YYYY')
          };
        }

        this.props?.fetchFigureData({
          currentPeriod: selectedPeriod,
          previousPeriod
        });

        this.fetchDashboardDataWithRequestParams(requestParams);
      }
    );
  };

  fetchDashboardDataWithRequestParams = (requestParams) => {
    const { authentication } = this.props;
    const isUsingUserManagement =
      getItemFromLocalStorage('user-management-enabled') === 'true';
    if (isUsingUserManagement) {
      if (
        authentication &&
        Array.isArray(authentication.data) &&
        authentication.data.length > 0
      ) {
        const listOfUiResources = authentication.data?.map((attributeItem) => {
          return attributeItem?.details?.resource?.resourceCode;
        });

        if (
          isUiResourceAvailable(
            tmUserManagementResources.TM_ALERTS_ANOMALIES_CHART_WIDGET,
            listOfUiResources
          )
        )
          this.props?.fetchAlertsAnomalies(requestParams);

        if (
          isUiResourceAvailable(
            tmUserManagementResources.TM_ALERTS_YIELD_CHART_WIDGET,
            listOfUiResources
          )
        )
          this.props?.fetchAlertsYield(requestParams);

        if (
          isUiResourceAvailable(
            tmUserManagementResources.TM_NO_ISSUE_L1_CHART_WIDGET,
            listOfUiResources
          )
        )
          this.props?.fetchNoIssueL1(requestParams);

        if (
          isUiResourceAvailable(
            tmUserManagementResources.TM_STR_CHART_WIDGET,
            listOfUiResources
          )
        )
          this.props?.fetchStr(requestParams);

        if (
          isUiResourceAvailable(
            tmUserManagementResources.TM_SEGMENTS_CHART_WIDGET,
            listOfUiResources
          )
        )
          this.props?.fetchAlertStatusBreakdown(requestParams);

        if (
          isUiResourceAvailable(
            tmUserManagementResources.TM_CUSTOMER_VIEW_CHART_WIDGET,
            listOfUiResources
          )
        )
          this.props?.fetchCustomerViewData(requestParams);

        if (
          isUiResourceAvailable(
            tmUserManagementResources.TM_CLUSTER_VIEW_CHART_WIDGET,
            listOfUiResources
          )
        )
          this.props?.fetchCustomerCluster(requestParams);
      }
    } else {
      this.props?.fetchAlertsAnomalies(requestParams);
      this.props?.fetchAlertsYield(requestParams);
      this.props?.fetchNoIssueL1(requestParams);
      this.props?.fetchStr(requestParams);
      this.props?.fetchAlertStatusBreakdown(requestParams);
      this.props?.fetchCustomerViewData(requestParams);
      this.props?.fetchCustomerCluster(requestParams);
    }
  };

  reloadAlertStatusBreakdownData = () => {
    const { selectedDateRange } = this.state;
    const requestParams = {
      to: moment(selectedDateRange.endDate).format('DD/MM/YYYY'),
      from: moment(selectedDateRange.startDate).format('DD/MM/YYYY')
    };
    this.props?.fetchAlertStatusBreakdown(requestParams);
  };

  reloadAlertsAndAnomaliesData = () => {
    const { selectedDateRange } = this.state;
    const requestParams = {
      to: moment(selectedDateRange.endDate).format('DD/MM/YYYY'),
      from: moment(selectedDateRange.startDate).format('DD/MM/YYYY')
    };

    this.props?.fetchAlertsAnomalies(requestParams);
  };

  reloadAlertsYieldData = () => {
    const { selectedDateRange } = this.state;
    const requestParams = {
      to: moment(selectedDateRange.endDate).format('DD/MM/YYYY'),
      from: moment(selectedDateRange.startDate).format('DD/MM/YYYY')
    };

    this.props?.fetchAlertsYield(requestParams);
  };

  reloadCustomerClusterData = () => {
    const { selectedDateRange } = this.state;
    let requestParams = {
      to: moment(selectedDateRange.endDate).format('DD/MM/YYYY'),
      from: moment(selectedDateRange.startDate).format('DD/MM/YYYY')
    };

    this.props?.fetchCustomerCluster(requestParams);
  };

  reloadCustomerViewData = () => {
    const { selectedDateRange, selectedSegmentCustomerView } = this.state;
    let requestParams = {
      to: moment(selectedDateRange.endDate).format('DD/MM/YYYY'),
      from: moment(selectedDateRange.startDate).format('DD/MM/YYYY')
    };

    if (selectedSegmentCustomerView.code !== '-') {
      requestParams['segment'] = selectedSegmentCustomerView.code;
    }

    this.props?.fetchCustomerViewData(requestParams);
  };

  reloadFigureData = () => {
    const { selectedDateRange } = this.state;

    const selectedPeriod = {
      from: selectedDateRange.startDate.clone().format('DD/MM/YYYY'),
      to: selectedDateRange.endDate.clone().format('DD/MM/YYYY')
    };

    let previousPeriod = null;
    const clonedStartDate = selectedDateRange.startDate.clone();
    const clonedEndDate = selectedDateRange.endDate.clone();

    const difference = clonedEndDate.diff(clonedStartDate);
    if (difference === 86399000) {
      previousPeriod = {
        from: clonedStartDate.subtract(difference).format('DD/MM/YYYY'),
        to: clonedEndDate.subtract(difference + 1).format('DD/MM/YYYY')
      };
    } else {
      previousPeriod = {
        from: clonedStartDate.subtract(difference).format('DD/MM/YYYY'),
        to: clonedEndDate.subtract(difference).format('DD/MM/YYYY')
      };
    }

    this.props?.fetchFigureData({
      currentPeriod: selectedPeriod,
      previousPeriod
    });
  };

  reloadNoIssueL1Data = () => {
    const { selectedDateRange } = this.state;
    const requestParams = {
      to: moment(selectedDateRange.endDate).format('DD/MM/YYYY'),
      from: moment(selectedDateRange.startDate).format('DD/MM/YYYY')
    };

    this.props?.fetchNoIssueL1(requestParams);
  };

  reloadStrData = () => {
    const { selectedDateRange } = this.state;
    const requestParams = {
      to: moment(selectedDateRange.endDate).format('DD/MM/YYYY'),
      from: moment(selectedDateRange.startDate).format('DD/MM/YYYY')
    };

    this.props?.fetchStr(requestParams);
  };

  toggleAlertStatusBreakdownPanel = () => {
    const { isAlertStatusBreakdownCollapsed } = this.state;
    this.setState({
      ...this.state,
      isAlertStatusBreakdownCollapsed: !isAlertStatusBreakdownCollapsed
    });
  };

  toggleAlertsAndAnomaliesChartPanel = () => {
    const { isAlertsAndAnomaliesCollapsed } = this.state;
    this.setState({
      ...this.state,
      isAlertsAndAnomaliesCollapsed: !isAlertsAndAnomaliesCollapsed
    });
  };

  toggleAlertsYieldChartPanel = () => {
    const { isAlertsYieldCollapsed } = this.state;
    this.setState({
      ...this.state,
      isAlertsYieldCollapsed: !isAlertsYieldCollapsed
    });
  };

  toggleCustomerClusterPanel = () => {
    const { isCustomerClusterCollapsed } = this.state;
    this.setState({
      ...this.state,
      isCustomerClusterCollapsed: !isCustomerClusterCollapsed
    });
  };

  toggleCustomerViewPanel = () => {
    const { isCustomerViewCollapsed } = this.state;
    this.setState({
      ...this.state,
      isCustomerViewCollapsed: !isCustomerViewCollapsed
    });
  };

  toggleNoIssueL1ChartPanel = () => {
    const { isNoIssueL1Collapsed } = this.state;
    this.setState({
      ...this.state,
      isNoIssueL1Collapsed: !isNoIssueL1Collapsed
    });
  };

  toggleStrChartPanel = () => {
    const { isStrCollapsed } = this.state;
    this.setState({
      ...this.state,
      isStrCollapsed: !isStrCollapsed
    });
  };

  renderAlertStatusBreakdownData = () => {
    const { isAlertStatusBreakdownCollapsed, alertStatusBreakdownFilter } =
      this.state;
    const { dashboard } = this.props;
    if (dashboard?.alertStatusChartData) {
      const alertStatusBreakdownData = Array.isArray(
        dashboard?.alertStatusChartData?.data
      )
        ? dashboard?.alertStatusChartData?.data
        : [];
      const alertStatusBreakdownIsLoading = dashboard.alertStatusChartData?.data
        ? dashboard.alertStatusChartData.isLoading
        : null;
      const segmentList = dashboard.segmentListData?.data
        ? dashboard.segmentListData.data
        : [];

      // Format data to not display code but description
      const formattedAlertStatusBreakdownData = [];
      alertStatusBreakdownData?.forEach((segmentData) => {
        Array.isArray(segmentList) &&
          segmentList.forEach((segmentListData) => {
            if (segmentData.segment === segmentListData.code) {
              formattedAlertStatusBreakdownData.push({
                ...segmentData,
                segment: segmentListData.description
              });
            }
          });
      });

      const alertTypes = [
        {
          id: 'str',
          name: 'STR'
        },
        {
          id: 'noIssue',
          name: 'No Issue'
        },
        {
          id: 'anomaly',
          name: 'Anomaly'
        }
      ];

      const alertStatusSegments = [];
      if (Array.isArray(segmentList) && segmentList.length > 0) {
        segmentList.forEach((o) => {
          alertStatusSegments.push({
            code: o.code,
            id: o.code,
            name: o.description
          });
        });
      }

      const filterGroupData = {
        title: 'Alerts & Segments',
        groupData: [
          {
            title: 'Alerts',
            data: ConfigData.IS_NCD_NOT_AVAILABLE
              ? alertTypes.filter((obj) => obj.id != 'anomaly')
              : alertTypes
          },
          {
            title: 'Segments',
            data: alertStatusSegments
          }
        ]
      };

      return (
        <AlertStatusBreakdownChart
          onTogglePanelVisibility={this.toggleAlertStatusBreakdownPanel}
          isCollapsed={isAlertStatusBreakdownCollapsed}
          isLoading={alertStatusBreakdownIsLoading}
          data={formattedAlertStatusBreakdownData}
          onReload={this.reloadAlertStatusBreakdownData}
          filterGroupData={filterGroupData}
          userFilterSetting={alertStatusBreakdownFilter}
          onFilter={this.onAlertBreakdownChartFilter}
        />
      );
    }

    return null;
  };

  renderAlertsAndAnomalies = () => {
    const { isAlertsAndAnomaliesCollapsed } = this.state;
    const { dashboard } = this.props;
    if (dashboard?.alertsAnomaliesChartData) {
      const alertsAndAnomaliesData = dashboard.alertsAnomaliesChartData?.data
        ? dashboard.alertsAnomaliesChartData.data
        : null;
      const alertsAndAnomaliesIsLoading = dashboard.alertsAnomaliesChartData
        ?.data
        ? dashboard.alertsAnomaliesChartData.isLoading
        : null;
      return (
        <AlertsAndAnomaliesChart
          onTogglePanelVisibility={this.toggleAlertsAndAnomaliesChartPanel}
          isCollapsed={isAlertsAndAnomaliesCollapsed}
          isLoading={alertsAndAnomaliesIsLoading}
          data={alertsAndAnomaliesData}
          onReload={this.reloadAlertsAndAnomaliesData}
        />
      );
    }

    return null;
  };

  renderAlertsYieldData = () => {
    const { isAlertsYieldCollapsed } = this.state;
    const { dashboard } = this.props;
    if (dashboard?.alertsYieldChartData) {
      const alertsYieldData = dashboard.alertsYieldChartData?.data
        ? dashboard.alertsYieldChartData.data
        : null;
      const alertsYieldIsLoading = dashboard.alertsYieldChartData?.data
        ? dashboard.alertsYieldChartData.isLoading
        : null;
      return (
        <AlertsYieldChart
          onTogglePanelVisibility={this.toggleAlertsYieldChartPanel}
          isCollapsed={isAlertsYieldCollapsed}
          isLoading={alertsYieldIsLoading}
          data={alertsYieldData}
          onReload={this.reloadAlertsYieldData}
        />
      );
    }

    return null;
  };

  renderCustomerClusterData = () => {
    const { isCustomerClusterCollapsed, selectedCustomerClusterAxis } =
      this.state;
    const { dashboard } = this.props;
    if (dashboard?.customerViewChartData) {
      const customerClusterData = dashboard.customerClusterChartData?.data
        ? dashboard.customerClusterChartData.data
        : null;
      const customerClusterIsLoading = dashboard.customerClusterChartData?.data
        ? dashboard.customerClusterChartData.isLoading
        : null;

      return (
        <ClusterViewChart
          data={customerClusterData}
          isLoading={customerClusterIsLoading}
          isCollapsed={isCustomerClusterCollapsed}
          onTogglePanelVisibility={this.toggleCustomerClusterPanel}
          onReload={this.reloadCustomerClusterData}
          onAxisChange={this.onClusterViewAxisChange}
          selectedAxis={selectedCustomerClusterAxis}
        />
      );
    }

    return null;
  };

  renderCustomerViewData = () => {
    const { isCustomerViewCollapsed, selectedSegmentCustomerView } = this.state;
    const { dashboard } = this.props;
    if (dashboard?.customerViewChartData) {
      const customerViewData = dashboard.customerViewChartData?.data
        ? dashboard.customerViewChartData.data
        : [];
      const customerViewIsLoading = dashboard.customerViewChartData?.data
        ? dashboard.customerViewChartData.isLoading
        : null;
      const segmentList = dashboard.segmentListData?.data
        ? dashboard.segmentListData.data
        : [];

      let trimmedDowndata =
        Array.isArray(customerViewData) && customerViewData.length > 0
          ? customerViewData.slice(0, 25)
          : [];

      // format data for better front-end integration
      const formattedData = trimmedDowndata.map((o) => {
        const {
          name,
          citizenship,
          isStaff,
          age,
          segment,
          postalCode,
          customerId,
          alertCount,
          address,
          type,
          residency,
          occupation,
          gender
        } = o;
        return {
          alertCount,
          name,
          customer: {
            isStaff,
            partyKey: customerId,
            partyName: name,
            occupation,
            customerAge: age,
            segmentName: segment,
            customerGender: gender,
            customerNationality: citizenship,
            customerLocation: address,
            postalCode,
            customerCountryOfResidence: residency,
            type
          }
        };
      });

      return (
        <CustomerViewChart
          data={formattedData}
          segmentList={segmentList}
          selectedSegment={selectedSegmentCustomerView}
          isLoading={customerViewIsLoading}
          isCollapsed={isCustomerViewCollapsed}
          onTogglePanelVisibility={this.toggleCustomerViewPanel}
          onReload={this.reloadCustomerViewData}
          onSegmentChange={this.onCustomerViewSegmentChange}
        />
      );
    }

    return null;
  };

  renderDashboardHeaderControls = () => {
    const { selectedDateRange } = this.state;
    return (
      <div className={classnames('row', styles.dashboardHeaderControls)}>
        <div className="col-md-12">
          <div className={styles.dateRangeContainer}>
            <RangedDtPicker
              startDate={selectedDateRange.startDate}
              endDate={selectedDateRange.endDate}
              activeRangeNo={selectedDateRange.activeRangeNo}
              onDateChange={this.onDateChange}
            />
          </div>
        </div>
      </div>
    );
  };

  renderFigures = () => {
    const { dashboard } = this.props;
    if (dashboard?.figureData) {
      const figureData = dashboard.figureData?.data
        ? dashboard.figureData.data
        : null;
      const figureDataIsLoading = dashboard.figureData?.isLoading
        ? dashboard.figureData.isLoading
        : null;

      return (
        <FiguresSection
          data={figureData}
          isLoading={figureDataIsLoading}
          onReload={this.reloadFigureData}
        />
      );
    }
  };

  renderNoIssueL1Data = () => {
    const { isNoIssueL1Collapsed } = this.state;
    const { dashboard } = this.props;
    if (dashboard?.noIssueL1ChartData) {
      const noIssueL1Data = dashboard.noIssueL1ChartData?.data
        ? dashboard.noIssueL1ChartData.data
        : null;
      const noIssueL1IsLoading = dashboard.noIssueL1ChartData?.data
        ? dashboard.noIssueL1ChartData.isLoading
        : null;
      return (
        <NoIssueL1Chart
          onTogglePanelVisibility={this.toggleNoIssueL1ChartPanel}
          isCollapsed={isNoIssueL1Collapsed}
          isLoading={noIssueL1IsLoading}
          data={noIssueL1Data}
          onReload={this.reloadNoIssueL1Data}
        />
      );
    }

    return null;
  };

  renderStrData = () => {
    const { isStrCollapsed } = this.state;
    const { dashboard } = this.props;
    if (dashboard?.strChartData) {
      const strData = dashboard.strChartData?.data
        ? dashboard.strChartData.data
        : null;
      const strIsLoading = dashboard.strChartData?.data
        ? dashboard.strChartData.isLoading
        : null;
      return (
        <StrChart
          onTogglePanelVisibility={this.toggleStrChartPanel}
          isCollapsed={isStrCollapsed}
          isLoading={strIsLoading}
          data={strData}
          onReload={this.reloadStrData}
        />
      );
    }

    return null;
  };

  render() {
    const { authentication } = this.props;
    const isUsingUserManagement =
      getItemFromLocalStorage('user-management-enabled') === 'true';
    // make it default to true if user management is not used
    const defaultUserManagementFlag = isUsingUserManagement ? false : true;
    let isAlertsAndAnomaliesAllowed = defaultUserManagementFlag;
    let isAlertsYieldAllowed = defaultUserManagementFlag;
    let isNoIssueL1Allowed = defaultUserManagementFlag;
    let isStrAllowed = defaultUserManagementFlag;
    let isSegmentsViewAllowed = defaultUserManagementFlag;
    let isCustomerViewAllowed = defaultUserManagementFlag;
    let isClusterViewAllowed = defaultUserManagementFlag;

    // start iterating widgets if authentication data is available
    // and if user management is allowed
    if (isUsingUserManagement) {
      // check if authentication data is there (UI resources)
      if (
        authentication &&
        Array.isArray(authentication.data) &&
        authentication.data.length > 0
      ) {
        const listOfUiResources = authentication.data?.map((attributeItem) => {
          return attributeItem?.details?.resource?.resourceCode;
        });

        if (
          isUiResourceAvailable(
            tmUserManagementResources.TM_ALERTS_ANOMALIES_CHART_WIDGET,
            listOfUiResources
          )
        )
          isAlertsAndAnomaliesAllowed = true;

        if (
          isUiResourceAvailable(
            tmUserManagementResources.TM_ALERTS_YIELD_CHART_WIDGET,
            listOfUiResources
          )
        )
          isAlertsYieldAllowed = true;

        if (
          isUiResourceAvailable(
            tmUserManagementResources.TM_NO_ISSUE_L1_CHART_WIDGET,
            listOfUiResources
          )
        )
          isNoIssueL1Allowed = true;

        if (
          isUiResourceAvailable(
            tmUserManagementResources.TM_STR_CHART_WIDGET,
            listOfUiResources
          )
        )
          isStrAllowed = true;

        if (
          isUiResourceAvailable(
            tmUserManagementResources.TM_SEGMENTS_CHART_WIDGET,
            listOfUiResources
          )
        )
          isSegmentsViewAllowed = true;

        if (
          isUiResourceAvailable(
            tmUserManagementResources.TM_CUSTOMER_VIEW_CHART_WIDGET,
            listOfUiResources
          )
        )
          isCustomerViewAllowed = true;

        if (
          isUiResourceAvailable(
            tmUserManagementResources.TM_CLUSTER_VIEW_CHART_WIDGET,
            listOfUiResources
          )
        )
          isClusterViewAllowed = true;
      }
    }

    return (
      <div className="row">
        <div className="col-md-12">
          {/* Header for DatePicker and Individual & Corporate toggle */}

          {this.renderDashboardHeaderControls()}

          {/* Figures Section */}

          {this.renderFigures()}

          {(isAlertsAndAnomaliesAllowed || isAlertsYieldAllowed) && (
            <div className={classnames('row', styles.chartsSection)}>
              {isAlertsAndAnomaliesAllowed && (
                <div className="col-md-6">
                  {/* Alerts and Anomalies chart goes here */}
                  {this.renderAlertsAndAnomalies()}
                </div>
              )}

              {isAlertsYieldAllowed && (
                <div className="col-md-6">
                  {/* Alerts Yield chart goes here */}
                  {this.renderAlertsYieldData()}
                </div>
              )}
            </div>
          )}

          {(isNoIssueL1Allowed || isStrAllowed) && (
            <div className={classnames('row', styles.chartsSection)}>
              {isNoIssueL1Allowed && (
                <div className="col-md-6">
                  {/* No Issue and L1 chart goes here */}
                  {this.renderNoIssueL1Data()}
                </div>
              )}

              {isStrAllowed && (
                <div className="col-md-6">
                  {/* STR chart goes here */}
                  {this.renderStrData()}
                </div>
              )}
            </div>
          )}

          {isSegmentsViewAllowed && (
            <div className={classnames('row', styles.chartsSection)}>
              <div className="col-md-12">
                {/* Alert Status Breakdown chart goes here */}
                {this.renderAlertStatusBreakdownData()}
              </div>
            </div>
          )}

          {isCustomerViewAllowed && (
            <div className={classnames('row', styles.chartsSection)}>
              <div className="col-md-12">
                {/* Customer View */}
                {this.renderCustomerViewData()}
              </div>
            </div>
          )}

          {isClusterViewAllowed && (
            <div className={classnames('row', styles.chartsSection)}>
              <div className="col-md-12">
                {/* Cluster View */}
                {this.renderCustomerClusterData()}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps = {}) {
  return {
    dashboard: state.tmDashboard,
    authentication: state.authentication
  };
}

function mapDispatchToProps(dispatch, ownProps = {}) {
  return {
    fetchFigureData: (payload) => dispatch(getFigureData(payload)),
    fetchAlertsAnomalies: (payload) =>
      dispatch(getAlertsAnomaliesChart(payload)),
    fetchAlertsYield: (payload) => dispatch(getAlertsYieldChart(payload)),
    fetchNoIssueL1: (payload) => dispatch(getNoIssueL1Chart(payload)),
    fetchStr: (payload) => dispatch(getStrChart(payload)),
    fetchAlertStatusBreakdown: (payload) =>
      dispatch(getAlertStatusChart(payload)),
    fetchSegmentList: () => dispatch(getSegmentListData()),
    fetchCustomerViewData: (payload) => dispatch(getCustomerData(payload)),
    fetchCustomerCluster: (payload) =>
      dispatch(getCustomerClusterChart(payload))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
